<script>
    import Panel from "./content-panel/Panel.svelte";
    import { Circle } from 'svelte-loading-spinners';
    import { onMount, onDestroy } from 'svelte';
    import { Constans } from '../lib/Constants';
    import { navigateTo } from 'svelte-router-spa';
    import { t, locale, locales } from "../../scripts/i18n";

    export let params = {};
    let divHeight;

    const analyzeElapsedTime = 10000;

    let scanProgress = params.stage ? params.stage.analyzeStats.scanProgress : 0;
    let followingsScanned = params.stage ? params.stage.analyzeStats.followingsScanned : 0;
    let followersScanned = params.stage ? params.stage.analyzeStats.followersScanned : 0;
    let botsFound = params.stage ? params.stage.analyzeStats.botsFound : 0;
    let commercialsFound = params.stage ? params.stage.analyzeStats.commercialsFound : 0;
    let nonReciprocalFound = params.stage ? params.stage.analyzeStats.nonReciprocalFound : 0;
    let inactiveFound = params.stage ? params.stage.analyzeStats.inactiveFound : 0;
    let foreignersFound = params.stage ? params.stage.analyzeStats.foreignersFound : 0;
    let unattainableFound = params.stage ? params.stage.analyzeStats.unattainableFound : 0;
    let timeLeft = params.stage ? params.stage.analyzeStats.timeLeft : analyzeElapsedTime;
    let timeLeftInSeconds = 10;
    $: timeLeft && (timeLeftInSeconds = Math.round(timeLeft / 1000));

    let username = null;
    $: params && (username = params.stage ? params.stage.account.username : null);

    $: params && (params.stage.status !== Constans.ANALYZE_STARTED) && navigateTo('/demo');

    let progressInterval;
    onMount(() => {
        window.scrollTo(0, 0);
        progressInterval = setInterval(() => {
            if (scanProgress < 100) {
                scanProgress += 1;
                timeLeft -= 100;
                if (followingsScanned < 355) {
                    followingsScanned += 2 + (Math.floor(Math.random() * 4));
                }
                if (followersScanned < 10849) {
                    followersScanned += 100 + (Math.floor(Math.random() * 9));
                }
                if (botsFound < 498) {
                    botsFound += 3 + (Math.floor(Math.random() * 4));
                }
                if (commercialsFound < 291) {
                    commercialsFound += 2 + (Math.floor(Math.random() * 2));
                }
                if (nonReciprocalFound < 147) {
                    nonReciprocalFound += 1 + (Math.floor(Math.random() * 2));
                }
                if (inactiveFound < 278) {
                    inactiveFound += 2 + (Math.floor(Math.random() * 2));
                }
                if (foreignersFound < 39) {
                    foreignersFound += 1;
                }
                if (unattainableFound < 327) {
                    unattainableFound += 3 + (Math.floor(Math.random() * 3));
                }

                params.setStage({
                    analyzeStats: {
                        scanProgress,
                        followingsScanned,
                        followersScanned,
                        botsFound,
                        commercialsFound,
                        nonReciprocalFound,
                        inactiveFound,
                        foreignersFound,
                        unattainableFound,
                        timeLeft,
                    }
                })

            } else {
                clearInterval(progressInterval);
                params.setStage({
                    status: Constans.ANALYZE_FINISHED,
                    analyzeStats: {
                        scanProgress: 0,
                        followingsScanned: 0,
                        followersScanned: 0,
                        botsFound: 0,
                        commercialsFound: 0,
                        nonReciprocalFound: 0,
                        inactiveFound: 0,
                        foreignersFound: 0,
                        unattainableFound: 0,
                        timeLeft: analyzeElapsedTime,
                    }
                });
                navigateTo('/demo/analyze-finished');
            }
        }, 100)
    });

    function backToDashboard() {
        params.setStage({
            status: Constans.ANALYZE_FINISHED,
            analyzeStats: {
                scanProgress: 100,
                followingsScanned: 355,
                followersScanned: 10849,
                botsFound: 498,
                commercialsFound: 291,
                nonReciprocalFound: 147,
                inactiveFound: 278,
                foreignersFound: 39,
                unattainableFound: 327,
                timeLeft: 0,
            }
        });
        clearInterval(progressInterval);
        navigateTo('/demo');
    }

    function stopAnalyze() {
        params.setStage({
            status: Constans.ANALYZE_FINISHED,
            analyzeStats: {
                scanProgress: 100,
                followingsScanned: 355,
                followersScanned: 10849,
                botsFound: 498,
                commercialsFound: 291,
                nonReciprocalFound: 147,
                inactiveFound: 278,
                foreignersFound: 39,
                unattainableFound: 327,
                timeLeft: 0,
            }
        });
        clearInterval(progressInterval);
        navigateTo('/demo/analyze-finished');
    }

    onDestroy(() => {
        try {
            if (progressInterval) {
                clearInterval(progressInterval);
            }
        } catch (err) {}
    });



</script>

<div class="analyze-in-progress-wrap position-relative" style={`min-height: ${divHeight}px;`}>
    <div class="banner-top">

    </div>

    <div class="inner-content-wrap position-absolute top-0 w-100pc" bind:clientHeight={divHeight}>
        <Panel>
            <span slot="title">{$t('Scan and cleaning')}</span>
            <span slot="back-btn">
                <a href="#" on:click={backToDashboard}>
                    <img src="/static/media/back.9eb4f248.svg" width="30" alt="/">
                </a>
            </span>
            <div slot="content">
                <div class="status-panel">
                    <ul class="list-inline">
                        <li class="active">{$t('Step 1: Scan')}</li>
                        <li class="list-inline-none">{$t('Step 2: Settings and cleaning')}</li>
                        <li class="list-inline-none">{$t('Step 3: Result')}</li>
                    </ul>
                </div>
                <div class="stats-wrap">
                    <div class="scan-block_content-step1">
                        <div class="row">
                            <div class="col-lg-5 col-md-5">
                                <div class="scan-block_content-step1-img">
                                    <img src="/static/media/flat-color-icons_search.3be78905.svg" alt="/" style="width: 100%;">
                                </div>
                            </div>
                            <div class="col-lg-7 col-md-7 ">
                                <p class="scan-block_content-step1-h">
                                    <span>
                                        {$t('Account @photographer.london scan in progress...')}
                                    </span>
                                    <Circle size="19" color="#000" unit="px" duration="1s" />
                                </p>
                                <div class="stats-wrap mb-20px">
                                    <div class="stat-item">
                                        <div class="stat-description">
                                            {$t('Scan progress')}
                                        </div>
                                        <div class="stat-value">
                                            <span>{scanProgress}%</span>
                                        </div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-description">
                                            {$t('Followings scanned')}
                                        </div>
                                        <div class="stat-value">
                                            <span>{followingsScanned}</span>
                                        </div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-description">
                                            {$t('Followers scanned')}
                                        </div>
                                        <div class="stat-value">
                                            <span>{followersScanned}</span>
                                        </div>
                                    </div>

                                    <div class="hr-line"></div>

                                    <div class="stat-item">
                                        <div class="stat-description">
                                            {$t('Bots detected')}
                                        </div>
                                        <div class="stat-value">
                                            <span>{botsFound}</span>
                                        </div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-description">
                                            {$t('Commercials detected')}
                                        </div>
                                        <div class="stat-value">
                                            <span>{commercialsFound}</span>
                                        </div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-description">
                                            {$t('Inactive accounts detected')}
                                        </div>
                                        <div class="stat-value">
                                            <span>{inactiveFound}</span>
                                        </div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-description">
                                            {$t('Foreign accounts detected')}
                                        </div>
                                        <div class="stat-value">
                                            <span>{foreignersFound}</span>
                                        </div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-description">
                                            {$t('Unattainable accounts detected')}
                                        </div>
                                        <div class="stat-value">
                                            <span>{unattainableFound}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="controls-wrap">
                                    <a href="#" type="button" class="purple-btn purple-btn_hover w-190px h-45px" style="width: 250px;" on:click={stopAnalyze}>{$t('Stop scanning')}</a>
                                    <span class="scan-clear-timer hide">{$t('Time left')}: {timeLeftInSeconds}s</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Panel>
    </div>

</div>

<style>
    .scan-block_content-step1-h {
        display: flex;
        justify-content: left;
        align-items: center;
    }
    .scan-block_content-step1-h > span {
        flex-grow: 1;
    }
    .controls-wrap {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .list-inline {
        margin: 0;
        border-bottom: 0.3px solid #8a8585;
        padding-left: 0;
        list-style: none;
    }

    .list-inline .active {
        font-weight: 600;
        border-bottom: 5px solid indigo;
    }
    .list-inline li {
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        color: #909090;
        padding: 15px 25px;
    }
    .list-inline>li {
        display: inline-block;
    }

</style>